export default {
    videoParams: {
        video_duration: 0,
        view_duration: 0,
    },
};
